function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import isClient from './util/detectClient';
import request from './util/request';
import configurable from './util/configurable';
import { getUserID, Config, trackID, HB_SESSION_ID_KEY } from './util/config';
import cookie from './util/cookie';
import { camelToUnder } from './util/json';

// 上报字段设计文档
// https://doc.baijia.com/sheets/qeK4Xdxva72RSLWM/y7NM8

var HB_SESSION_ID_VALUE = cookie.get(HB_SESSION_ID_KEY);

/**
 * 点、展、滚动、停留上报
 *
 * @function
 * @param {Object} json 要上报的数据
 * @param {Function=} callback 上报后的回调
 */

var report = configurable(function (json, callback) {
  if (!isClient) {
    return;
  }

  // 多取几次appNid是为了兼容历史传参情况
  var appNid = Config.APPNID || Config.appNid || Config.appId;
  if (json.metric) {
    var metric = json.metric;
    Object.assign(json, _defineProperty({}, HB_SESSION_ID_KEY, HB_SESSION_ID_VALUE || cookie.get(HB_SESSION_ID_KEY)));

    // 轻舟上用来聚合number类型的统计字段名 values, 如果是value
    var values;
    var value;

    // 针对 stay 接口 at, bt, tt 需要统计的字段，特殊处理
    if (metric === 'stay') {
      values = JSON.stringify({
        at: json.at,
        bt: json.bt,
        tt: json.tt
      });
      // 避免影响数据聚合后统计维度
      delete json.at;
      delete json.bt;
      delete json.tt;
    }
    // 针对其他接口，中的value、values 进行处理，轻舟【指标分析】可以进行聚合分析
    else if (json.value && !Number.isNaN(+json.value)) {
      value = json.value;
    } else if (json.values) {
      values = json.values;
    }
    var reportData = {
      actionStart: Date.now(),
      appNid: appNid,
      metric: metric,
      userID: getUserID(),
      trackID: trackID,
      tags: JSON.stringify(json)
    };
    Object.assign(reportData, {
      values: values
    }, {
      value: value
    });
    request(Config.VERB)("".concat(Config.METRIC), camelToUnder(reportData), callback);
  }
}, {});
export default report;